import type { TypographyVariantsOptions } from '@mui/material/styles';
import { palette } from './palette';

const fontFamilyBody = '"Inter", system-ui, -apple-system, sans-serif';
const fontFamilyHeadline = '"Sora", system-ui, -apple-system, sans-serif';
const headingColor = palette.darkNavy;

export const typography: TypographyVariantsOptions = {
  fontFamily: fontFamilyBody,
  body1: {
    fontSize: 16,
    fontWeight: 400,
  },
  body2: {
    fontSize: 14,
    fontWeight: 400,
  },
  small: {
    fontSize: 12,
    fontWeight: 400,
  },
  h1: {
    fontFamily: fontFamilyHeadline,
    fontSize: 32,
    fontWeight: 400,
    color: headingColor,
  },
  h2: {
    fontFamily: fontFamilyHeadline,
    fontSize: 24,
    fontWeight: 400,
    color: headingColor,
  },
  h3: {
    fontFamily: fontFamilyHeadline,
    fontSize: 20,
    fontWeight: 400,
    color: headingColor,
  },
  h4: {
    fontFamily: fontFamilyHeadline,
    fontSize: 18,
    fontWeight: 400,
    color: headingColor,
  },
  h5: {
    fontFamily: fontFamilyHeadline,
    fontSize: 16,
    fontWeight: 400,
    color: headingColor,
  },
  h6: {
    fontFamily: fontFamilyHeadline,
    fontSize: 14,
    fontWeight: 400,
    color: headingColor,
  },
  subtitle1: {
    fontFamily: fontFamilyBody,
    fontSize: 16,
    fontWeight: 600,
    color: headingColor,
  },
  subtitle2: {
    fontFamily: fontFamilyBody,
    fontSize: 14,
    fontWeight: 500,
    color: headingColor,
  },
  caption: {
    fontSize: 11,
    fontWeight: 400,
  },
};
